<template>
  <div
    class="flex flex-col justify-center rounded-md border border-light-gray p-4"
  >
    <div class="flex items-center gap-2">
      <div
        v-if="info?.icon == 'icon-lock'"
        class="h-6 w-6 text-dark-gray"
      >
        <svg
          class="h-full w-full"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="3"
            y="10"
            width="18"
            height="13"
            rx="2"
            stroke="currentColor"
            stroke-width="2"
          />
          <path
            d="M17 10V6C17 4.34315 15.6569 3 14 3H10C8.34315 3 7 4.34315 7 6V10"
            stroke="currentColor"
            stroke-width="2"
          />
          <circle
            cx="12"
            cy="15"
            r="2"
            fill="currentColor"
          />
          <rect
            x="11"
            y="16"
            width="2"
            height="3"
            rx="1"
            fill="currentColor"
          />
        </svg>
      </div>
      <div
        v-else-if="info?.icon == 'icon-not-allowed'"
        class="h-6 w-6 text-dark-gray"
      >
        <svg
          class="h-full w-full"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="2"
          />
          <path
            d="M5 19L19 5"
            stroke="currentColor"
            stroke-width="2"
          />
        </svg>
      </div>
      <div
        v-else-if="info?.icon == 'icon-page'"
        class="h-6 w-6 text-dark-gray"
      >
        <svg
          class="h-full w-full"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 23H20C20.5523 23 21 22.5523 21 22V11.1679C21 10.917 20.9057 10.6753 20.7358 10.4907L12.2971 1.32276C12.1077 1.11705 11.8409 1 11.5613 1H4C3.44772 1 3 1.44772 3 2V22C3 22.5523 3.44772 23 4 23Z"
            stroke="currentColor"
            stroke-width="2"
          />
          <path
            d="M12.5 11H19.8773C20.3102 11 20.5386 10.4873 20.249 10.1655L12.8716 1.9685C12.5651 1.62789 12 1.84474 12 2.30298V10.5C12 10.7761 12.2239 11 12.5 11Z"
            stroke="currentColor"
            stroke-width="2"
          />
        </svg>
      </div>
      <div
        v-else-if="info?.icon == 'icon-email'"
        class="h-6 w-6 text-dark-gray"
      >
        <svg
          class="h-full w-full"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 19H20C20.5523 19 21 18.5523 21 18V6C21 5.44772 20.5523 5 20 5H4C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19Z"
            stroke="currentColor"
            stroke-width="2"
          />
          <path
            d="M3 5L12 13L21 5"
            stroke="currentColor"
            stroke-width="2"
          />
        </svg>
      </div>
      <div
        v-else-if="info?.icon == 'icon-calendar'"
        class="h-6 w-6 text-dark-gray"
      >
        <svg
          class="h-full w-full"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="3"
            y="4"
            width="18"
            height="16"
            rx="2"
            stroke="currentColor"
            stroke-width="2"
          />
          <path
            d="M2 8H22"
            stroke="currentColor"
            stroke-width="2"
          />
          <rect
            x="16"
            y="2"
            width="2"
            height="4"
            fill="currentColor"
          />
          <rect
            x="6"
            y="2"
            width="2"
            height="4"
            fill="currentColor"
          />
        </svg>
      </div>
      <div
        v-else-if="info?.icon == 'man-icon'"
        class="h-6 w-6 text-dark-gray"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="7.76465"
            y="3"
            width="8.47059"
            height="8.47059"
            rx="4.23529"
            stroke="#313545"
            stroke-width="2"
          />
          <path
            d="M20 21V21C20 17.6863 17.3137 15 14 15H10C6.68629 15 4 17.6863 4 21V21"
            stroke="#313545"
            stroke-width="2"
          />
        </svg>
      </div>
      <div
        v-else-if="info?.icon == 'mail-icon'"
        class="h-6 w-6 text-dark-gray"
      >
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 4.5H20C21.1 4.5 22 5.4 22 6.5V18.5C22 19.6 21.1 20.5 20 20.5H4C2.9 20.5 2 19.6 2 18.5V6.5C2 5.4 2.9 4.5 4 4.5Z"
            stroke="#313545"
            stroke-width="2.08333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M22 6.5L12 13.5L2 6.5"
            stroke="#313545"
            stroke-width="2.08333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div
        v-else-if="info?.icon == 'report-icon'"
        class="h-6 w-6 text-dark-gray"
      >
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.05279 20.3556L5 20.882V3.5H9H11.5H14H18V20.882L16.9472 20.3556L16.5 20.132L16.0528 20.3556L14 21.382L11.9472 20.3556L11.5 20.132L11.0528 20.3556L9 21.382L6.94721 20.3556L6.5 20.132L6.05279 20.3556Z"
            stroke="#313545"
            stroke-width="2"
          />
          <path
            d="M7.125 9.5H15.875"
            stroke="#313545"
            stroke-width="2"
          />
          <path
            d="M7.125 14.5H15.875"
            stroke="#313545"
            stroke-width="2"
          />
        </svg>
      </div>
      <h4
        class="whitespace-pre-line text-left text-sm font-medium sm:text-base"
      >
        {{ info?.title }}
      </h4>
    </div>
    <div class="mt-2 leading-none">
      <span
        class="flex text-left text-xs text-gray-500"
        style="line-height: 1.1"
      >
        {{ info?.content }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InformationPanel',
  props: {
    info: Object,
  },
};
</script>
